export default "__VITE_ASSET__BS1CEnq9__"